module.exports = __webpack_public_path__ + "static/img/suuc.644b4ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/suuc.png
// module id = 4ufj
// module chunks = 1